import React from 'react';

const TextoOrganizado = ({ texto }) => {
  if (!texto || typeof texto !== 'string') {
    return null;
  }

  const lines = texto.split('\n').filter(line => {
    const trimmedLine = line.trim();
    if (trimmedLine === '') return false;
    if (trimmedLine.startsWith('[ioredis]')) return false;
    if (trimmedLine.startsWith('📨') || trimmedLine.startsWith('🔎')) return false;
    if (trimmedLine.includes('Nombre o fecha inválida:')) return false;
    return true;
  });
  
  const applyBold = (line) => {
    const parts = line.split(/\*\*(.*?)\*\*/g);
    return parts.map((part, index) => {
      return index % 2 === 1 ? <strong key={index}>{part}</strong> : part;
    });
  };

  const content = [];
  let listStack = [];

  lines.forEach((line, index) => {
    const indentation = line.match(/^\s*/)[0].length;
    const trimmedLine = line.trim();

    while (listStack.length > 0 && indentation < listStack[listStack.length - 1].indentation) {
      const closedList = listStack.pop();
      if (listStack.length > 0) {
        const parentList = listStack[listStack.length - 1];
        const lastItem = parentList.items.pop();
        const newItemWithNestedList = React.cloneElement(
          lastItem,
          { key: lastItem.key },
          [...React.Children.toArray(lastItem.props.children), <ul key={`ul-nested-${index}`}>{closedList.items}</ul>]
        );
        parentList.items.push(newItemWithNestedList);
      } else {
        content.push(<ul key={`ul-${index}`}>{closedList.items}</ul>);
      }
    }

    if (trimmedLine.startsWith('-') || trimmedLine.startsWith('•')) {
      const textContent = trimmedLine.substring(1).trim();
      if (listStack.length === 0) {
        listStack.push({ indentation: indentation, items: [] });
      } else if (indentation > listStack[listStack.length - 1].indentation) {
         const newList = { indentation: indentation, items: [] };
         listStack.push(newList);
      }
      const colonIndex = textContent.indexOf(':');
      let listItemContent;
      if (colonIndex > -1 && colonIndex < 30) {
        const title = textContent.substring(0, colonIndex + 1);
        const description = textContent.substring(colonIndex + 1);
        listItemContent = <>{applyBold(title)}{applyBold(description)}</>;
      } else {
        listItemContent = applyBold(textContent);
      }
      listStack[listStack.length - 1].items.push(<li key={index}>{listItemContent}</li>);
    } else {
        while(listStack.length > 0) {
            const closedList = listStack.pop();
            if (listStack.length > 0) {
                const parentList = listStack[listStack.length - 1];
                const lastItem = parentList.items.pop();
                const newItemWithNestedList = React.cloneElement(
                  lastItem,
                  { key: lastItem.key },
                  [...React.Children.toArray(lastItem.props.children), <ul key={`ul-nested-title-${index}`}>{closedList.items}</ul>]
                );
                parentList.items.push(newItemWithNestedList);
            } else {
                content.push(<ul key={`ul-title-close-${index}`}>{closedList.items}</ul>);
            }
        }
      
      const isNumberedTitle = /^\d+\.\s/.test(trimmedLine);
      const isShortTitle = trimmedLine.split(' ').length < 6 && !trimmedLine.endsWith('.') && !trimmedLine.endsWith(':');
      const isAQuestion = trimmedLine.endsWith('?');

      if ((isNumberedTitle || isShortTitle) && !isAQuestion) {
          content.push(<h3 key={index}>{applyBold(trimmedLine)}</h3>);
      } else {
          content.push(<p key={index}>{applyBold(trimmedLine)}</p>);
      }
    }
  });

  while (listStack.length > 0) {
    const closedList = listStack.pop();
     if (listStack.length > 0) {
        const parentList = listStack[listStack.length - 1];
        const lastItem = parentList.items.pop();
        const newItemWithNestedList = React.cloneElement(
          lastItem,
          { key: lastItem.key },
          [...React.Children.toArray(lastItem.props.children), <ul key={`ul-final-nested`}>{closedList.items}</ul>]
        );
        parentList.items.push(newItemWithNestedList);
    } else {
        content.push(<ul key="final-ul">{closedList.items}</ul>);
    }
  }

  return <div className="texto-organizado">{content}</div>;
};

export default TextoOrganizado;